// extracted by mini-css-extract-plugin
export default {"boxes":"boxesViev_boxes__FoILW","outside":"boxesViev_outside__gdifQ","sentence":"boxesViev_sentence__h2pvq","slider":"boxesViev_slider__J5I0f","image":"boxesViev_image__xBJEg"};